// ============================================
// CHÁMOMILE Design System — Warm Minimalism Palette
// ============================================

export const colors = {
    // Brand Gold
    gold50: '#FDF6EE', gold100: '#f5f0e6', gold200: '#ebe0cc', gold300: '#dccaa6',
    gold400: '#D4A853', gold500: '#c9a962', gold600: '#a07d2e', gold700: '#846628',
    // Warm Neutrals
    stone50: '#fafaf9', stone100: '#f5f5f4', stone200: '#e7e5e4', stone300: '#d6d3d1',
    stone400: '#a8a29e', stone500: '#78716c', stone600: '#57534e', stone700: '#44403c',
    stone800: '#292524', stone900: '#1c1917',
    // Dark / Black for buttons
    black50: '#1C1917', black100: '#292524',
    // Semantic
    success: '#22c55e', successLight: '#dcfce7', error: '#E85D5D', info: '#3b82f6', infoLight: '#dbeafe',
    // Soft Luxury Café Palette
    bg: '#fffaf7', bgWarm: '#FDF6EE', surface: '#FFFFFF', accent: '#A8B89C', accentLight: '#EEF2EB',
    rose: '#E8A598', roseLight: '#FFF0ED', roseMuted: '#F5D6D0',
    sage: '#A8B89C', sageLight: '#E8EFE4',
    espresso: '#2E1A0E', espressoLight: '#5C3D2E',
    border: '#F0EDE8', textPrimary: '#2E1A0E', textSecondary: '#78716c', textMuted: '#a8a29e',
};
